import proj4 from 'proj4';
import * as Three from 'three/webgpu';
import { z } from 'zod';

import { CogniteAssetModel } from '#core/schema/model/cdm/CogniteAssetModel';
import { CogniteSourceableModel } from '#core/schema/model/cdm/CogniteSourceableModel';
import { CogniteVisualizableModel } from '#core/schema/model/cdm/CogniteVisualizableModel';

export const PlatformModel = z
  .object({
    ...CogniteAssetModel.shape,
    ...CogniteVisualizableModel.shape,
    ...CogniteSourceableModel.shape,

    fullName: z.string(),
    installationType: z.enum(['wellhead', 'island']),
    latitude: z.number(),
    longitude: z.number(),
  })
  .transform((instance) => {
    const [x, y] = proj4('EPSG:32639', [instance.longitude, instance.latitude]);
    const position = new Three.Vector3(x, 0, -y);

    return { ...instance, position };
  });

export type PlatformModelInput = z.input<typeof PlatformModel>;
export type PlatformModelOutput = z.output<typeof PlatformModel>;
